var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.697,
    height: 19.975,
    viewBox: "0 0 26.697 19.975",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_338",
    "data-name": "Group 338",
    transform: "translate(-1054.596 -225.658)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_337",
    "data-name": "Group 337"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6528",
    "data-name": "Path 6528",
    d: "M1067.912,245.631c-3.5,0-7,.007-10.5,0a2.584,2.584,0,0,1-2.7-1.911,3.362,3.362,0,0,1-.108-.941q-.014-7.1,0-14.2a2.7,2.7,0,0,1,2.852-2.906c.557-.011,1.113-.011,1.669,0,.5.014.867.24.862.783s-.374.755-.873.768c-.436.012-.876.012-1.311,0-.623-.01-1.249.033-1.49.721a2,2,0,0,0,.3,2.132,3.374,3.374,0,0,0,.7.548q3.94,2.418,7.887,4.824a4.853,4.853,0,0,0,5.456.014q4.206-2.608,8.426-5.2a1.944,1.944,0,0,0,.563-2.2c-.145-.554-.573-.833-1.352-.834q-6.086-.009-12.17-.006a1.522,1.522,0,0,1-.758-.065c-.25-.159-.553-.467-.556-.714s.306-.54.55-.724c.144-.11.422-.059.638-.059q6.146,0,12.29,0a2.7,2.7,0,0,1,2.976,3q.006,5.637,0,11.274c0,1.111.081,2.228-.029,3.327a2.633,2.633,0,0,1-2.707,2.354C1074.99,245.638,1071.451,245.632,1067.912,245.631Zm-11.642-13.807a1.635,1.635,0,0,0-.079.284c0,3.58-.014,7.158,0,10.737,0,.851.436,1.209,1.353,1.21q10.379,0,20.759,0c1,0,1.369-.375,1.369-1.373q.009-5.04,0-10.08c0-.207-.033-.413-.061-.716-.3.153-.514.245-.714.366q-3.681,2.265-7.36,4.538a6.378,6.378,0,0,1-7.147.02c-1.544-.941-3.084-1.892-4.624-2.839Z",
    fill: "#7e97b8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6529",
    "data-name": "Path 6529",
    d: "M1063.332,226.451c.006.456-.382.769-.948.766s-.959-.33-.959-.77c0-.455.376-.753.957-.759C1062.944,225.684,1063.329,225.992,1063.332,226.451Z",
    fill: "#7e97b8",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.d135d2e29b3097205e649bffa4ec6b13.svg";
export { ForwardRef as ReactComponent };